import React, { useEffect, useRef, useState } from "react";
import { Form, Input, Spin, Select, InputNumber, Divider, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../features/save/saveSlice";
import BreadCrumb from "../../../layout/BreadCrumb";
import {
  fetchCounties,
  fetchLocation,
  fetchSubCounties,
  fetchSubLocation,
  fetchData,
} from "../../../features/fetch/fetchSlice";
import CardLoading from "../../../components/CardLoading";
import { schReclStatusData } from "../../../data";

const TreeCatchmentAdd = () => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const urlRsrveType = "reserve_type/fetch_reservetypes";
  const urlHarvstng = "water_harvesting/fetch_waterharvestings";
  const urlPathway = "api/v2/irrigationPathway/get";
  const urlTypography = "typography/fetch_typographys";
  const urlWard = "ward/fetch_wards";
  const urlConstituency = "constituency/fetch_constituencys";

  const { saving } = useSelector((state) => state.save);
  const { counties, subCounties, locations, subLocations } = useSelector(
    (state) => state.fetch
  );
  const {
    loading,
    activeObjTree,
    dataHarvstng,
    dataReserve,
    dataPathway,
    dataTypography,
    dataConstituency,
    dataWard,
  } = useSelector((state) => ({
    activeObjTree: state.obj.activeObj["tree"],
    dataHarvstng: state.fetch.data[urlHarvstng] || [],
    dataReserve: state.fetch.data[urlRsrveType] || [],
    dataPathway: state.fetch.data[urlPathway] || [],
    dataTypography: state.fetch.data[urlTypography] || [],

    dataWard: state.fetch.data[urlWard] || [],
    dataConstituency: state.fetch.data[urlConstituency] || [],
  }));

  const dispatch = useDispatch();
  const navigate = useNavigate();

  function handleCancel() {
    navigate("/rob/triangular-micro-catchment-for-trees");
  }
  const [tmcCountyId, setTmcCountyId] = useState(
    activeObjTree?.tmcCountyId ?? ""
  );
  const [tmcConstId, setTmcConstId] = useState(activeObjTree?.tmcConstId ?? "");
  const [tmcSubCountyId, setTmcSubCountyId] = useState(
    activeObjTree?.tmcSubCountyId ?? ""
  );
  const [tmcLocationId, setTmcLocationId] = useState(
    activeObjTree?.tmcLocationId ?? ""
  );
  const [tmcSubLocationId, setTmcSubLocationId] = useState(
    activeObjTree?.tmcSubLocationId ?? ""
  );
  const [tmcWardId, setTmcWardId] = useState(activeObjTree?.tmcWardId ?? "");

  const handleTmcCountyChange = async (value) => {
    setTmcCountyId(value);
    setTmcConstId("");
    setTmcSubCountyId("");
    setTmcLocationId("");
    setTmcSubLocationId("");
    setTmcWardId("");

    form.setFieldsValue({
      tmcCountyId: value,
      tmcConstId: "",
      tmcSubCountyId: "",
      tmcLocationId: "",
      tmcSubLocationId: "",
      tmcWardId: "",
    });

    await dispatch(fetchSubCounties({ subCountyId: value }));
    await dispatch(fetchData({ url: urlConstituency, constCountyId: value }));
  };

  const handleTmcConstituencyChange = async (value) => {
    setTmcConstId(value);
    setTmcWardId("");

    form.setFieldsValue({
      tmcConstId: value,
      tmcWardId: "",
    });

    await dispatch(fetchData({ url: urlWard, wdConstId: value }));
  };

  const handleTmcSubCountyChange = async (value) => {
    setTmcSubCountyId(value);
    setTmcLocationId("");
    setTmcSubLocationId("");

    form.setFieldsValue({
      tmcSubCountyId: value,
      tmcLocationId: "",
      tmcSubLocationId: "",
    });

    await dispatch(fetchLocation({ locSubId: value }));
  };

  const handleTmcLocationChange = async (value) => {
    setTmcLocationId(value);
    setTmcSubLocationId("");

    form.setFieldsValue({
      tmcLocationId: value,
      tmcSubLocationId: "",
    });

    await dispatch(fetchSubLocation({ slocLocId: value }));
  };

  const handleTmcSubLocationChange = (value) => {
    setTmcSubLocationId(value);
    form.setFieldsValue({ tmcSubLocationId: value });
  };

  const handleTmcWardChange = (value) => {
    setTmcWardId(value);
    form.setFieldsValue({ tmcWardId: value });
  };

  const onFinish = async (data) => {
    data.tmcId = activeObjTree?.tmcId ? activeObjTree?.tmcId : null;

    data.tmcPathwayId = Array.isArray(data?.tmcPathwayId)
      ? data?.tmcPathwayId.join(",")
      : data?.tmcPathwayId;

    const res = await dispatch(
      save({
        ...data,
        url: "tree_micro_catchment/save_treemicrocatchment",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await form.resetFields();
      await handleCancel();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      ...activeObjTree,
    });
    if (activeObjTree?.tmcPathwayId) {
      form.setFieldsValue({
        tmcPathwayId: activeObjTree?.tmcPathwayId
          ?.split(",")
          ?.map((b) => b?.trim()),
      });
    }
  }, [activeObjTree, form]);

  const initialFormValues = {
    ...activeObjTree,
  };

  useEffect(() => {
    dispatch(fetchCounties());
    dispatch(
      fetchData({
        url: urlRsrveType,
        limit: null,
        start: 0,
      })
    );
    dispatch(
      fetchData({
        url: urlHarvstng,
        limit: null,
        start: 0,
      })
    );
    dispatch(
      fetchData({
        url: urlPathway,
        limit: null,
        start: 0,
      })
    );
    dispatch(
      fetchData({
        url: urlTypography,
        limit: null,
        start: 0,
      })
    );
  }, []);
  useEffect(() => {
    if (activeObjTree?.tmcId) {
      dispatch(fetchSubCounties({ subCountyId: activeObjTree?.tmcCountyId }));
      dispatch(
        fetchData({
          url: urlConstituency,
          constCountyId: activeObjTree?.tmcCountyId,
        })
      );
      dispatch(
        fetchData({ url: urlWard, wdConstId: activeObjTree?.tmcConstId })
      );
      dispatch(fetchLocation({ locSubId: activeObjTree?.tmcSubCountyId }));
      dispatch(fetchSubLocation({ slocLocId: activeObjTree?.tmcLocationId }));
    }
  }, [activeObjTree, form]);

  if (loading) return <CardLoading />;

  return (
    <div className="w-full ">
      <BreadCrumb
        breadcrumbs={[
          {
            title: "Tree Catchment List",
            path: "/rob/triangular-micro-catchment-for-trees",
          },
          { title: "Tree Catchment Add Form" },
        ]}
      />
      <div className="white_card mt-[2.06rem]">
        <div className="w-full">
          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            onFinish={onFinish}
            className=""
            style={{
              maxWidth: "100%",
            }}
            form={form}
            initialValues={initialFormValues}
          >
            <div className="custom-title !bg-white !px-0">
              Triangular Micro Catchment For Trees Details
            </div>
            <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
              <Form.Item
                name="tmcName"
                label={"Project Name"}
                rules={[
                  {
                    required: true,
                    message: "Please add project name",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>
              <Form.Item
                name="tmcStatus"
                className=""
                label={"Status"}
                rules={[
                  {
                    required: true,
                    message: "Please select status",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    schReclStatusData?.length > 0 &&
                    schReclStatusData?.map((item) => ({
                      value: item?.value,
                      label: item?.label,
                    }))
                  }
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </Form.Item>
              <Form.Item
                name="tmcCountyId"
                label="County"
                rules={[{ required: true, message: "Please select county" }]}
              >
                <Select
                  allowClear
                  options={counties?.map((c) => ({
                    value: c?.countyId,
                    label: c?.countyName,
                  }))}
                  onChange={handleTmcCountyChange}
                  showSearch
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase()?.includes(input.toLowerCase())
                  }
                />
              </Form.Item>

              {tmcCountyId && (
                <>
                  <Form.Item
                    name="tmcConstId"
                    label="Constituency"
                    rules={[
                      { required: true, message: "Please select constituency" },
                    ]}
                  >
                    <Select
                      allowClear
                      options={dataConstituency?.map((c) => ({
                        value: c?.constId,
                        label: c?.constName,
                      }))}
                      onChange={handleTmcConstituencyChange}
                      showSearch
                      filterOption={(input, option) =>
                        option?.label
                          ?.toLowerCase()
                          ?.includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>

                  <Form.Item
                    name="tmcSubCountyId"
                    label="Subcounty"
                    rules={[
                      { required: true, message: "Please select subcounty" },
                    ]}
                  >
                    <Select
                      allowClear
                      options={subCounties?.map((s) => ({
                        value: s?.subId,
                        label: s?.subCountyName,
                      }))}
                      onChange={handleTmcSubCountyChange}
                      showSearch
                      filterOption={(input, option) =>
                        option?.label
                          ?.toLowerCase()
                          ?.includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>
                </>
              )}

              {tmcSubCountyId && (
                <Form.Item
                  name="tmcLocationId"
                  label="Location"
                  rules={[
                    { required: true, message: "Please select location" },
                  ]}
                >
                  <Select
                    allowClear
                    options={locations?.map((l) => ({
                      value: l?.locId,
                      label: l?.locLocation,
                    }))}
                    onChange={handleTmcLocationChange}
                    showSearch
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                  />
                </Form.Item>
              )}

              {tmcLocationId && (
                <Form.Item
                  name="tmcSubLocationId"
                  label="Sublocation"
                  rules={[
                    { required: true, message: "Please select sublocation" },
                  ]}
                >
                  <Select
                    allowClear
                    options={subLocations?.map((sl) => ({
                      value: sl?.slocId,
                      label: sl?.slocLocation,
                    }))}
                    onChange={handleTmcSubLocationChange}
                    showSearch
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                  />
                </Form.Item>
              )}

              {tmcConstId && (
                <Form.Item
                  name="tmcWardId"
                  label="Ward"
                  rules={[{ required: true, message: "Please select ward" }]}
                >
                  <Select
                    allowClear
                    options={dataWard?.map((w) => ({
                      value: w?.wdId,
                      label: w?.wdWard,
                    }))}
                    onChange={handleTmcWardChange}
                    showSearch
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                  />
                </Form.Item>
              )}

              <Form.Item
                name="tmcLat"
                label={"Latitude (Decimal degrees, WGS84)"}
                rules={[
                  {
                    required: true,
                    message: "Please add latitude",
                  },
                ]}
              >
                <InputNumber
                  parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                  className="input flex"
                />
              </Form.Item>
              <Form.Item
                name="tmcLong"
                label={"Longitude (Decimal degrees, WGS84)"}
                rules={[
                  {
                    required: true,
                    message: "Please add longitude",
                  },
                ]}
              >
                <InputNumber
                  parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                  className="input flex"
                />
              </Form.Item>

              <Form.Item
                name="tmcSize"
                label={"Size (Acres)"}
                rules={[
                  {
                    required: true,
                    message: "Please add size",
                  },
                ]}
              >
                <InputNumber
                  parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                  className="input flex"
                />
              </Form.Item>

              <Form.Item
                name="tmcGroundSlopeId"
                className=""
                label={"Slope of The Ground"}
                rules={[
                  {
                    required: true,
                    message: "Please add slope of the ground",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    dataTypography?.length > 0 &&
                    dataTypography?.map((item) => ({
                      value: item?.typoId,
                      label: item?.typoTypography,
                    }))
                  }
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </Form.Item>

              <Form.Item
                name="tmcTreeTypeGrown"
                label={"Types of Trees Grown "}
                rules={[
                  {
                    required: true,
                    message: "Please add Types of trees grown ",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>
              <Form.Item
                name="tmcWaterHarvestingId"
                className=""
                label={"Method of Water Harvesting,"}
                rules={[
                  {
                    required: true,
                    message: "Please select method of water harvesting,",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    dataHarvstng?.length > 0 &&
                    dataHarvstng?.map((item) => ({
                      value: item?.whId,
                      label: item?.whType,
                    }))
                  }
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </Form.Item>
              <Form.Item
                name="tmcFenceType"
                label={"Type of Fence Used"}
                rules={[
                  {
                    required: true,
                    message: "Please add type of fence used",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>
              <Form.Item
                name="tmcVegetationTypeGrown"
                label={"Type of Vegetation"}
                rules={[
                  {
                    required: true,
                    message: "Please add type of vegetation",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>
              <Form.Item
                name="tmcAnimalGrazedType"
                label={"Type of Animals Being Grazed"}
                rules={[
                  {
                    required: true,
                    message: "Please add type of animals being grazed",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>
              <Form.Item
                name="tmcWaterSourceDirection"
                label={"Source of Water"}
                rules={[
                  {
                    required: true,
                    message: "Please add source of water",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>
              <Form.Item
                name="tmcReserveArea"
                label={"Area of The Reserve"}
                rules={[
                  {
                    required: true,
                    message: "Please add Maximum Area of the reserve",
                  },
                ]}
              >
                <InputNumber
                  suffix={"Acre"}
                  min={0}
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                  placeholder="Enter value"
                  className="input flex"
                />
              </Form.Item>
              <Form.Item
                name="tmcReserveTypeId"
                className=""
                label={"Type of Reserve"}
                rules={[
                  {
                    required: true,
                    message: "Please select type of reserve",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    dataReserve?.length > 0 &&
                    dataReserve?.map((item) => ({
                      value: item?.rtId,
                      label: item?.rtType,
                    }))
                  }
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </Form.Item>
              <Form.Item
                label={"Pathways"}
                name="tmcPathwayId"
                rules={[
                  {
                    required: true,
                    message: "Please add pathways",
                  },
                ]}
              >
                <Select
                  mode="multiple"
                  allowClear
                  showSearch
                  dropdownRender={(menu) => (
                    <>
                      <Space style={{ padding: "8px 8px 4px" }}>
                        <span className="select-info mt-1">
                          Choose one or more of the following pathways
                        </span>
                      </Space>
                      <Divider style={{ margin: "8px 0" }} />
                      {menu}
                    </>
                  )}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.children?.toLowerCase() ?? "").includes(
                      input.toLowerCase()
                    )
                  }
                  dropdownStyle={{ maxHeight: 400, overflowY: "auto" }}
                >
                  {dataPathway?.length > 0 &&
                    dataPathway?.map((item) => (
                      <Select.Option
                        key={item?.irrigationPathwayId}
                        value={item?.irrigationPathwayId}
                      >
                        {item?.irrigationPathwayName}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="tmcTypographyId"
                className=""
                label={"Topography"}
                rules={[
                  {
                    required: true,
                    message: "Please select topography",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    dataTypography?.length > 0 &&
                    dataTypography?.map((item) => ({
                      value: item?.typoId,
                      label: item?.typoTypography,
                    }))
                  }
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </Form.Item>
            </div>

            <div className="flex justify-between mt-[48px] ">
              <div className="justify-start"></div>
              <div className="justify-end flex items-center mb-[58px] gap-x-5">
                <div className="w-[150px]">
                  <button
                    type="button"
                    key="back"
                    onClick={handleCancel}
                    className="cstm-btn"
                  >
                    Cancel
                  </button>
                </div>

                <div className="w-[150px]">
                  <button key="submit" type="submit" className="cstm-btn-2">
                    {saving ? (
                      <Spin />
                    ) : activeObjTree?.tmcId ? (
                      "Update"
                    ) : (
                      "Save"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};
export default TreeCatchmentAdd;
